var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaded || !_vm.error)?_c('div',{staticClass:"preview-image",on:{"click":function($event){return _vm.showMedia()}}},[_c('img',{attrs:{"src":_vm.previewUrl,"alt":"thumbnail"}})]):_c('div',{staticClass:"preview-image"},[_c('img',{attrs:{"src":(_vm.isThumbnail ? '/storage/thumb/fallback' : '/storage/preview/fallback'),"alt":"thumbnail"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }